import { z } from 'zod';

import { columnBaseSchema } from '../base';
import { columnHorizontalAlignSchema, columnWidthSchema } from '../shared';

/**
 * A header/footer slot. It carries two knobs and nothing else, which the legacy
 * seed already said out loud: `createLegacyColumn('specific')` leaves all three
 * style bags empty and `.specific-column-styles()` reads no box variable —
 * the row paints the background, and the column settings panel is unreachable
 * for a header column (`navigation-column-item` bails on `isSpecific()`).
 *
 * `horizontalAlign` is written once, from the slot the column sits in
 * (left/center/right), and never edited afterwards.
 */
export const columnSpecificDataSchema = z.object({
    /** Always `col`: a header row has no flexible-width mode. */
    width: columnWidthSchema,
    horizontalAlign: columnHorizontalAlignSchema,
});

export const columnSpecificSchema = columnBaseSchema.extend({
    entitySubType: z.literal('specific'),
    props: columnSpecificDataSchema,
    version: z.literal(0),
});

export const columnSpecificV0Schema = columnSpecificSchema;
export type ColumnSpecificV0 = z.infer<typeof columnSpecificV0Schema>;
